import {cva} from 'class-variance-authority'

/**
 * `Link` styling — MUI `Link` contract (`color` × `underline`).
 *
 * Font family is pinned to the DS sans (Nunito) so a bare `<Link>` isn't the
 * browser serif default; font *size* is intentionally inherited so an inline
 * link matches the surrounding text (defaults to the 16px browser base = body1).
 * Hover does not change color (per Figma) — only the `hover` underline variant
 * reacts to hover.
 */
export const linkVariants = cva(
  'cursor-pointer rounded-sm font-sans focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
  {
    variants: {
      color: {
        primary: 'text-primary',
        inherit: 'text-inherit',
      },
      underline: {
        always: 'underline',
        hover: 'no-underline hover:underline',
        none: 'no-underline',
      },
    },
    defaultVariants: {
      color: 'primary',
      underline: 'always',
    },
  },
)
